import { VARIANT_DEFAULT, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, DATA_STATE_SELECTED, ELEMENT_BUTTON, } from '../../constants';
import { getBackgroundColor, getBorderColor, getColor, getOutlineColor, } from '../../colors/colors.alias';
import { getOutlineOffset, getOutlineStyle, getOutlineWidth, } from '../../borders/borders.alias';
import { getFontFamily, getFontSize, getLineHeight, } from '../../typography/typography.alias';
export const constants = Object.freeze({
    NAME: 'ToggleButton',
    variants: {
        VARIANT_DEFAULT,
    },
    interactionStates: {
        // No active state because button becomes selected
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
    dataStates: {
        DATA_STATE_SELECTED,
    },
    elements: {
        ELEMENT_BUTTON,
    },
});
export default function getToggleButton(transformer, config) {
    const outlineColor = getOutlineColor(transformer, config);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const backgroundColor = getBackgroundColor(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_BUTTON]: {
                styles: {
                    fontFamily: fontFamily.body.value,
                    fontSize: fontSize.body.m.value,
                    lineHeight: lineHeight.body,
                    color: color.text.default.value,
                    backgroundColor: backgroundColor.button.plain.default.value,
                    borderRadius: '4px',
                    borderWidth: '1px',
                    borderColor: borderColor.form.toggleButton.default.value,
                },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: {
                        styles: {
                            backgroundColor: 'transparent', //TODO: replace with alias token
                        },
                    },
                    [INTERACTION_STATE_FOCUS_VISIBLE]: {
                        styles: {
                            outlineWidth: outlineWidth.default.value,
                            outlineStyle: outlineStyle.default.value,
                            outlineOffset: outlineOffset.default.value,
                            outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                        },
                    },
                },
                dataStates: {
                    [DATA_STATE_SELECTED]: {
                        styles: {
                            color: color.text.default.value,
                            borderColor: borderColor.button.plain.withBorder.dataStates[DATA_STATE_SELECTED].value,
                            borderWidth: '2px',
                            backgroundColor: backgroundColor.contentContainer.plain.default.value,
                        },
                    },
                },
            },
        },
    });
}
